import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {connect} from 'react-redux';

import {LAYOUT_MODES} from 'App/layout/layoutConstants';
import {RootState} from 'App/store/rootReducer';
import {LAYOUT_TYPES} from '~/components/common/pages_constants';

import {MAP, MAP_2D_MODE} from './layoutTypes';

type LayoutSlice = {
  selectedMap: MAP;
  selectedMap2DMode: MAP_2D_MODE;
  layoutType: LAYOUT_TYPES;
  layoutMode: LAYOUT_MODES;
  isStreetViewVisible: boolean;
};

const initialState: LayoutSlice = {
  selectedMap: MAP.MAP_2D,
  selectedMap2DMode: MAP_2D_MODE.STANDARD,
  layoutType: LAYOUT_TYPES.HALF_VIEW,
  layoutMode: LAYOUT_MODES.WINDOW,
  isStreetViewVisible: false,
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    selectMap2d: state => {
      state.selectedMap = MAP.MAP_2D;
    },
    selectMap3d: state => {
      state.selectedMap = MAP.MAP_3D;
    },
    selectMapBirdView: state => {
      state.selectedMap = MAP.MAP_BIRD_VIEW;
    },
    selectMap2dModeStandard: state => {
      state.selectedMap2DMode = MAP_2D_MODE.STANDARD;
    },
    selectMap2dModeSatellite: state => {
      state.selectedMap2DMode = MAP_2D_MODE.SATELLITE;
    },
    selectMap2dModeStreetNames: state => {
      state.selectedMap2DMode = MAP_2D_MODE.STREET_NAMES;
    },
    setLayoutType: (state, {payload}: PayloadAction<LAYOUT_TYPES>) => {
      state.layoutType = payload;
    },
    setLayoutMode: (state, {payload}: PayloadAction<LAYOUT_MODES>) => {
      state.layoutMode = payload;
    },
    showStreetView: state => {
      state.isStreetViewVisible = true;
    },
    hideStreetView: state => {
      state.isStreetViewVisible = false;
    },
    toggleStreetView: state => {
      state.isStreetViewVisible = !state.isStreetViewVisible;
    },
  },
});

const mapLayoutToProps = (state: RootState): LayoutSlice => state.layout;
export const connectToLayout = connect(mapLayoutToProps, null, null, {
  forwardRef: true,
});

export const selectLayoutType = (state: RootState): LAYOUT_TYPES =>
  state.layout.layoutType;
export const selectLayoutMode = (state: RootState): LAYOUT_MODES =>
  state.layout.layoutMode;
export const selectMap = (state: RootState): MAP => state.layout.selectedMap;
export const selectMap2DMode = (state: RootState): MAP_2D_MODE =>
  state.layout.selectedMap2DMode;

export const {
  selectMap2d,
  selectMap3d,
  selectMap2dModeSatellite,
  selectMapBirdView,
  selectMap2dModeStandard,
  selectMap2dModeStreetNames,
  setLayoutType,
  setLayoutMode,
  showStreetView,
  hideStreetView,
  toggleStreetView,
} = layoutSlice.actions;

export default layoutSlice.reducer;
